<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <div v-if="product">
        <!-- 产品信息 -->
        <div class="proinfo">
          <div class="proinfo-top">
            <div class="proName">{{ product.P_NAME }}</div>
            <div class="seePrice" @click="toRequestInfo()">
              <span>索取信息与询价</span>
            </div>
          </div>
          <div class="proinfo-cont">
            <div class="left">
              <p class="title">{{ product.P_TITLE_ONE }}</p>
              <p class="desc">
                {{ product.P_NOTE_ONE }}
              </p>
              <p
                class="download"
                @click="downFile(product.P_FILENAME, product.P_PROPAGATE)"
              >
                <img src="../assets/tj.png" />
                <span>下载宣传册</span>
              </p>
            </div>
            <div class="right">
              <img :src="product.P_IMG" />
            </div>
          </div>
          <div class="proinfo-bottom"></div>
        </div>
        <!-- 易于操作和维护 -->
        <div class="safeguard">
          <div class="title">{{ product.P_TITLE_TWO }}</div>
          <div class="cont">
            {{ product.P_NOTE_TWO }}
          </div>
        </div>
        <!-- 特点与优势、规格 -->
        <div class="features">
          <ul class="optsList">
            <div
              class="optItem"
              :class="[currentIndex == index ? 'active' : '']"
              v-for="(item, index) in opts"
              :key="index"
              @click="switchOpt(index)"
            >
              <p>
                <span>{{ item.title }}</span>
              </p>
              <i></i>
            </div>
          </ul>
          <div
            class="features-detail"
            v-if="currentIndex == 0"
            v-html="product.P_ADVANTAGE"
          ></div>
          <div
            class="features-detail"
            v-if="currentIndex == 1"
            v-html="product.P_SPECIFICATION"
          ></div>
          <!-- 下载PDF -->
          <div class="features-downFile" v-if="specification.length != 0">
            <ul class="downFile-ul">
              <li
                class="downFile-item"
                v-for="(item, index) in specification"
                :key="index"
                @click="downFile(item.SPE_FILENAME, item.SPE_ANNX)"
              >
                <div>
                  <p class="title">{{ item.SPE_NAME }}</p>
                  <p class="describe">{{ item.SPE_NOTE }}</p>
                </div>
                <p class="downbtn">
                  <img src="../assets/tj.png" />
                  <span>下载(PDF)</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 去掉默认样式 */
p {
  margin-bottom: 0;
}

/* 详情 */
.proinfo {
  width: 80.4%;
  margin: 3.75rem 9.9% 0 9.7%;
}

.proinfo-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1.0625rem;
}

.proinfo-top .proName {
  width: calc(100% - 15rem);
  line-height: 3.625rem;
  font-size: 2.8125rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333333;
}

.proinfo-top .seePrice {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.125rem;
  height: 4.625rem;
  line-height: 1.375rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
  margin-right: 1.8125rem;
}

.proinfo-top .seePrice span {
  height: 1.375rem;
}

.proinfo-cont {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-family: Microsoft YaHei;
  text-align: left;
}

.proinfo-cont .left {
  width: 50%;
  padding: 0;
}

.proinfo-cont .title {
  line-height: 2.1875rem;
  font-size: 1.6875rem;
  font-weight: bold;
  color: #333333;
  margin-bottom: 1.125rem;
}

.proinfo-cont .desc {
  line-height: 1.875rem;
  font-size: 1.375rem;
  font-weight: 400;
  color: #333333;
  margin-bottom: 0.4375rem;
}

.proinfo-cont .download {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.125rem;
  height: 4.625rem;
  line-height: 1.375rem;
  font-size: 1.375rem;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
}

.proinfo-cont .download img {
  width: 1.4375rem;
  height: 0.6875rem;
  margin-right: 0.5625rem;
}

.proinfo-cont .download span {
  height: 1.375rem;
}

.proinfo-cont .right {
  width: 50%;
  padding-left: 13.9rem;
  padding-top: 0.625rem;
  box-sizing: border-box;
}

.proinfo-cont .right img {
  width: 19.0625rem;
  height: 21.875rem;
}

.proinfo-bottom {
  width: calc(100% - 0.5625rem);
  height: 1px;
  background: #d6d6d6;
  margin-left: 0.5625rem;
  margin-top: 2.5625rem;
}

.safeguard {
  width: 80.4%;
  /* margin: 0 190px 0 186px; */
  margin: 3.75rem 9.9% 0 9.7%;
  padding-top: 2.5rem;
  box-sizing: border-box;
}

.safeguard .title {
  width: 100%;
  line-height: 2.4375rem;
  font-size: 2.4375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333333;
}

.safeguard .cont {
  width: 100%;
  line-height: 1.9375rem;
  font-size: 1.4375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin: 2.0625rem 0 1.875rem;
}

.features {
  width: 80.4%;
  /* margin: 0 190px 0 186px; */
  margin: 3.75rem 9.9% 13rem 9.7%;
}

.optsList {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 0.3125rem solid #020e62;
  margin-bottom: 0;
}

.optItem {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.optItem p {
  line-height: 1.375rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  background: #fff;
  border-radius: 0.625rem 0.625rem 0px 0px;
  padding: 1.5rem 4.25rem;
  box-sizing: border-box;
}

.optItem i {
  width: 100%;
  height: 0.3125rem;
  background: transparent;
}

.optsList .active p {
  background: #f2f2f2;
}

.optsList .active i {
  background: #020e62;
}

.features-detail {
  width: 100%;
  line-height: 1.6875rem;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left;
  padding-top: 1.5625rem;
  padding-bottom: 2.8438rem;
  box-sizing: border-box;
}

.features-detail table {
  width: 100% !important;
}

.features-detail ul li {
  list-style: disc inside none;
}

.features-detail img {
  width: 100%;
}

/* 下载PDF */
.features-downFile {
  width: 100%;
  border-top: 0.5rem solid #020e62;
  padding-top: 1.375rem;
  box-sizing: border-box;
}

.downFile-ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 1.625rem;
}

.downFile-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc((100% - 3rem) / 3);
  text-align: left;
  background: #f2f2f2;
  padding: 1.75rem 3% 1.625rem;
  box-sizing: border-box;
  margin-bottom: 1.375rem;
  margin-right: 1rem;
}

.downFile-item .title {
  width: 100%;
  height: 5rem;
  line-height: 2.5rem;
  font-size: 1.75rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #020e62;
  padding-left: 0.1875rem;
  box-sizing: border-box;
  display: -webkit-box;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  /* 设置 需要显示的行数 */
  -webkit-line-clamp: 2;
}

.downFile-item .describe {
  width: 100%;
  line-height: 1.875rem;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 1.1875rem;
}

.downFile-item .downbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.125rem;
  height: 4.625rem;
  line-height: 1.3125rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
}

.downFile-item .downbtn img {
  width: 1.4375rem;
  height: 0.6875rem;
  margin-right: 0.5625rem;
}

.proinfo-cont .download span {
  height: 1.3125rem;
}

@media screen and (max-width: 1500px) {
  .proinfo,
  .safeguard,
  .features {
    /* width: 90%;
    margin: 3.75rem 5% 0; */
    width: 85%;
    margin: 3.5rem 8% 0 7%;
  }

  .features {
    margin: 3.5rem 8% 13rem 7%;
  }

  .safeguard {
    padding-top: 2.1rem;
  }

  .proinfo-top .proName {
    line-height: 3.6rem;
    font-size: 2.8rem;
  }

  .proinfo-cont .title {
    line-height: 2.1rem;
    font-size: 1.6rem;
  }

  .proinfo-cont .desc {
    line-height: 1.8rem;
    font-size: 1.3rem;
  }
  .proinfo-cont .right img {
    width: 19rem;
    height: 21.7rem;
  }

  .safeguard .cont {
    line-height: 1.9rem;
    font-size: 1.4rem;
    margin: 2rem 0 1.8rem;
  }

  .features-detail {
    line-height: 1.6rem;
    font-size: 1.2rem;
    padding-bottom: 2.8rem;
  }
  /* 
  .features-detail h4 {
    line-height: 3.1rem;
    font-size: 2.3rem;
    margin: 1.5rem 0 0.75rem;
  }

  .features-detail h5 {
    line-height: 2.5rem;
    font-size: 1.9rem;
    margin: 0 0 0.9rem;
  } */

  .downFile-item {
    padding: 1.75rem 2.5% 1.625rem;
  }

  .downFile-item .title {
    height: 5rem;
    line-height: 2.45rem;
    font-size: 1.7rem;
  }

  .downFile-item .describe {
    line-height: 1.8rem;
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 1200px) {
  .proinfo,
  .safeguard,
  .features {
    width: 87%;
    margin: 3.5rem 8% 0 6%;
  }

  .features {
    margin: 3.5rem 8% 23rem 6%;
  }

  .proinfo-cont .right {
    padding-left: 10%;
  }

  .safeguard {
    padding-top: 2rem;
  }

  .proinfo-top .proName {
    line-height: 3.5rem;
    font-size: 2.7rem;
  }

  .proinfo-cont .title {
    line-height: 2rem;
    font-size: 1.5rem;
  }

  .proinfo-cont .desc {
    line-height: 1.7rem;
    font-size: 1.2rem;
  }
  .proinfo-cont .right img {
    width: 18rem;
    height: 21rem;
  }

  .safeguard .cont {
    line-height: 1.8rem;
    font-size: 1.3rem;
    margin: 1.9rem 0 1.7rem;
  }

  .features-detail {
    line-height: 1.5rem;
    font-size: 1.1rem;
    padding-bottom: 2.6rem;
  }
  /* 
  .features-detail h4 {
    line-height: 3rem;
    font-size: 2.2rem;
    margin: 1.4rem 0 0.5rem;
  }

  .features-detail h5 {
    line-height: 2.4rem;
    font-size: 1.8rem;
    margin: 0 0 0.8rem;
  } */

  .downFile-item {
    padding: 1.7rem 2.3% 1.6rem;
  }

  .downFile-item .title {
    height: 4.5rem;
    line-height: 2.3rem;
    font-size: 1.6rem;
  }

  .downFile-item .describe {
    line-height: 1.7rem;
    font-size: 1.1rem;
  }
}

@media screen and (max-width: 990px) {
  .proinfo,
  .safeguard,
  .features {
    width: 88%;
    margin: 3rem 7% 0 5%;
  }

  .features {
    margin: 3rem 7% 23rem 5%;
  }

  .proinfo-cont .right {
    padding-left: 9%;
  }

  .proinfo-top .proName {
    line-height: 3.1rem;
    font-size: 2.5rem;
  }

  .proinfo-top .seePrice,
  .proinfo-cont .download {
    width: 12.125rem;
    height: 4rem;
    line-height: 1.375rem;
    font-size: 1.375rem;
    margin-right: 1.6rem;
  }

  .proinfo-cont .title {
    line-height: 2rem;
    font-size: 1.5rem;
    margin-bottom: 1.125rem;
  }

  .proinfo-cont .desc {
    line-height: 1.6rem;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .proinfo-cont .download {
    margin-right: 0;
  }

  .proinfo-cont .right img {
    width: 18rem;
    height: 20rem;
  }

  .proinfo,
  .safeguard {
    padding-top: 1.8rem;
  }

  .safeguard .title {
    width: 100%;
    line-height: 2rem;
    font-size: 2rem;
  }

  .safeguard .cont {
    line-height: 1.7rem;
    font-size: 1.1rem;
    margin: 1.8rem 0 1.6rem;
  }

  .features-detail {
    list-style: disc inside none;
    line-height: 1.5rem;
    font-size: 1.1rem;
  }
  /* 
  .features-detail h4 {
    line-height: 2rem;
    font-size: 1.5rem;
    margin: 1.5625rem 0 0.75rem;
  }

  .features-detail h5 {
    line-height: 1.8rem;
    font-size: 1.3rem;
    margin: 0 0 0.6rem;
  } */

  .downFile-item {
    width: calc((100% - 2rem) / 2);
  }

  .downFile-item .title {
    height: 4rem;
    line-height: 2.1rem;
    font-size: 1.5rem;
    padding-left: 0.15rem;
  }

  .downFile-item .describe {
    width: 100%;
    line-height: 1.6rem;
    font-size: 1rem;
    margin-bottom: 1.1rem;
  }

  .downFile-item .downbtn {
    width: 12.125rem;
    height: 4rem;
  }
}

@media screen and (max-width: 770px) {
  .proinfo-top .proName {
    line-height: 2.5rem;
    font-size: 2rem;
  }

  .proinfo-cont .title {
    line-height: 1.8rem;
    font-size: 1.2rem;
    margin-bottom: 1.125rem;
  }

  .proinfo-cont .desc {
    line-height: 1.5rem;
    font-size: 1rem;
    margin-bottom: 0.4375rem;
  }

  .proinfo-cont .right img {
    width: 16rem;
    height: 18rem;
  }

  .proinfo,
  .safeguard,
  .features {
    width: 90%;
    margin: 2rem 5% 0;
  }

  .features {
    width: 90%;
    margin: 2rem 5% 23rem;
  }

  .proinfo,
  .safeguard {
    padding-top: 1.5rem;
  }

  .safeguard .title {
    width: 100%;
    line-height: 2rem;
    font-size: 1.6rem;
  }

  .safeguard .cont {
    line-height: 1.5rem;
    font-size: 1rem;
    margin: 2rem 0 1rem;
  }

  .features-detail {
    list-style: disc inside none;
    line-height: 1.2rem;
    font-size: 1rem;
    padding-bottom: 1.6rem;
  }
  /* 
  .features-detail h4 {
    line-height: 2rem;
    font-size: 1.5rem;
    margin: 1.5625rem 0 0.75rem;
  }

  .features-detail h5 {
    line-height: 1.8rem;
    font-size: 1.3rem;
    margin: 0 0 0.6rem;
  } */

  .downFile-item .title {
    height: 4rem;
    line-height: 2.1rem;
    font-size: 1.5rem;
    padding-left: 0.15rem;
  }

  .downFile-item .describe {
    width: 100%;
    line-height: 1.2rem;
    font-size: 1rem;
    margin-bottom: 1.1rem;
  }
}

@media screen and (max-width: 600px) {
  .proinfo-bottom {
    width: 96%;
    margin-left: 2%;
    margin-top: 1.5rem;
  }

  .proinfo,
  .safeguard,
  .features {
    width: 96%;
    margin: 1.6rem 2% 0;
    padding-top: 0;
  }

  .features {
    margin: 1.6rem 2% 24rem;
  }

  .proinfo-top,
  .proinfo-cont {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .proinfo-top {
    flex-direction: column-reverse;
    margin-bottom: 0;
  }

  .proinfo-top .seePrice,
  .proinfo-cont .download {
    width: 12.125rem;
    height: 3rem;
    line-height: 1.2rem;
    font-size: 1.2rem;
    margin: 0 auto;
  }

  .proinfo-top .proName {
    width: 100%;
    line-height: 2rem;
    font-size: 1.6rem;
    margin-top: 1rem;
  }

  .proinfo-cont .left,
  .proinfo-cont .right {
    width: 100%;
  }

  .proinfo-cont .right {
    display: flex;
    justify-content: center;
    padding-left: 0;
  }
  .proinfo-cont .title {
    line-height: 1.5rem;
    font-size: 1.2rem;
    margin-top: 1rem;
  }
  .proinfo-cont .desc {
    line-height: 1.2rem;
    font-size: 1rem;
    margin-bottom: 0.4375rem;
  }

  .safeguard .cont {
    line-height: 1.2rem;
    font-size: 1rem;
    margin: 1.5rem 0 1rem;
  }
  .optItem p {
    line-height: 1.1rem;
    font-size: 1.1rem;
    border-radius: 0.5rem 0.5rem 0px 0px;
    padding: 1rem 0.5rem;
  }
  
  .features-detail ul {
    margin-left: 0!important;
  }

  .downFile-item {
    margin-bottom: 0.625rem;
    padding: 1rem 3% 0.8rem;
  }

  .downFile-item .title {
    height: 3.5rem;
    line-height: 1.6rem;
    font-size: 1.3rem;
    padding-left: 0.15rem;
  }

  .downFile-item .describe {
    width: 100%;
    line-height: 1.1rem;
    font-size: 1rem;
    margin-bottom: 1.1rem;
  }

  .downFile-item .downbtn {
    width: 100%;
    height: 3rem;
    line-height: 1.2rem;
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 499px) {
  .downFile-item {
    width: 100%;
    margin-right: 0;
    margin-bottom: 0.625rem;
    padding: 1rem 3% 0.8rem;
  }

  .downFile-item .downbtn {
    width: 12.5rem;
    height: 3rem;
    line-height: 1.2rem;
    font-size: 1.2rem;
    margin: 0 auto;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import { getBackground, getProductDetails } from "../api/interface"; // 引入接口
export default {
  name: "productDetail",
  components: {
    bottomFooter,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      product: null,
      currentIndex: 0,
      opts: [
        {
          title: "特点与优势",
        },
        {
          title: "规格",
        },
      ],
      specification: [],
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
    };
  },

  created() {
    console.log(this.$route.query.id);
    let DB_PRODUCT_ID = this.$route.query.id;
    this.getImg();
    this.getProductDetails(DB_PRODUCT_ID);
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;
      console.log("scrollTop", scrollTop);
      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "product-center" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 获取产品详情
    async getProductDetails(DB_PRODUCT_ID) {
      const that = this;
      await getProductDetails({ DB_PRODUCT_ID: DB_PRODUCT_ID }).then((res) => {
        console.log(res);
        that.$set(that, "product", res.product);
        let specification = res.specification;
        that.$set(that, "specification", specification);
      });
    },

    // 切换选项
    switchOpt(index) {
      console.log("点击的是选项" + index);
      this.$set(this, "currentIndex", index);
    },

    // 去请求信息页面
    toRequestInfo() {
      // 获取localStorage中的产品数组
      let productArray = JSON.parse(
        localStorage.getItem("productArray") || "[]"
      );
      // 将当前产品信息添加到数组中
      let product = {
        DB_PRODUCT_ID: this.product.DB_PRODUCT_ID,
        P_NAME: this.product.P_NAME,
        P_IMG: this.product.P_IMG,
        num: 1,
      };
      // 检查当前产品是否存在
      let exists = productArray.some(
        (v) => v.DB_PRODUCT_ID === product.DB_PRODUCT_ID
      );
      // 如果不存在就添加到列表中
      if (!exists) {
        productArray.push(product);
      }
      // 把更新后的产品数组保存到localStorage中
      localStorage.setItem("productArray", JSON.stringify(productArray));
      this.$router.push({ path: "/requestInfo" });
    },

    // 下载文件
    // downFile(url,fileName) {
    //   // window.open(filePath);
    // },
    /* 第一个参数是文件的名字，第二个参数是文件的路径*/

    downFile(fileName, data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  // beforeRouteLeave(to, from, next) {
  //   //设置下一个路由的meta,让列表页面缓存,即不刷新
  //   to.meta.keepAlive = true;
  //   next();
  // },
};
</script>
